<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row cRow">
          <div class="col-sm-6">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Fleet Master</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Drivers
                </li>
              </ol>
            </nav>
          </div>
          <!-- /.col-sm-6 -->
          <div class="col-sm-6">
            <div class="dataTables_filter pull-right">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Phone Number, Provider or Driver Name"
              />
            </div>
          </div>
          <!-- /.col-sm-6 -->
        </div>
        <!-- /.row -->
        <div class="row">
          <div class="col-sm-12">
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span> Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Drivers <span><i class="ic-car"></i></span>
                  </h2>
                  <p>
                    Manage and review your drivers. Drivers can be added here or
                    self-register through the driver mobile app.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row hidden">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Phone Number, Provider or Driver Name"
              />
            </div>
          </div>
          <div class="col-sm-6"></div>
          <!-- /.col-sm-6 -->
        </div>
        <div class="row">
          <div class="table-accordion table-p15">
            <table class="table table-hover table-striped table-sticky">
              <thead>
                <tr>
                  <th>
                    Name
                    <span class="button-sort" @click="onClickSort('fullName')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th>
                    Phone
                    <span class="button-sort" @click="onClickSort('phone')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th>Provider(s)</th>
                  <th>Language(s)</th>
                  <th class="text-left">Source</th>
                  <th class="text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>
                    {{ item.title ? `${item.title}.` : "" }}
                    {{ item.fullName }}
                  </td>
                  <td class="pos-rel">
                    {{ printPhone(item) }}
                    <div class="row-big-menu">
                      <ul>
                        <li v-if="!item.isOwnInventory">
                          <button
                            class="btn btn-default"
                            type="button"
                            @click="viewItem(item.id)"
                          >
                            <span>View</span>
                          </button>
                        </li>
                        <li v-if="item.isOwnInventory && isAllowToUpdate">
                          <button
                            class="btn btn-default --blue"
                            type="button"
                            @click="updateItem(item.id)"
                          >
                            <span>Edit</span>
                          </button>
                        </li>
                        <li v-if="item.isOwnInventory && isAllowToDelete">
                          <button
                            class="btn btn-default sts-danger"
                            type="button"
                            @click.prevent="openDeleteModal('driver', item.id)"
                          >
                            <span>Delete</span>
                          </button>
                        </li>
                        <li v-if="item.isOwnInventory && isAllowToUpdate">
                          <button
                            class="btn btn-default"
                            type="button"
                            @click="viewDocument(item)"
                          >
                            <span>Document</span>
                          </button>
                        </li>
                        <li
                          v-if="
                            item.isOwnInventory && !item.isSync && isAllowToSync
                          "
                        >
                          <button
                            class="btn btn-default --green35"
                            type="button"
                            @click="openAuthModal(item)"
                          >
                            <span>Sync User</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </td>
                  <td>{{ printProvider(item) }}</td>
                  <td>{{ printLanguage(item) }}</td>
                  <td class="text-left">{{ item.source }}</td>
                  <td class="text-left">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        :disabled="!item.isOwnInventory || !isAllowToUpdate"
                        @change="changeStatus(item)"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_length mt-15">
              <label>
                Show
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                <span>from</span
                ><strong class="pl-10 --blue25">{{ recordInfo }}</strong></label
              >
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="drivermodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Driver</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body mt-5">
                  <ul
                    class="nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"
                  >
                    <li :class="[activeTab === 'general' ? 'active' : '']">
                      <a
                        href="#driver-general"
                        data-toggle="tab"
                        @click="activeTab = 'general'"
                      >
                        <span class="required">General</span>
                      </a>
                    </li>
                    <li :class="[activeTab === 'provider' ? 'active' : '']">
                      <a
                        href="#driver-provider"
                        data-toggle="tab"
                        @click="activeTab = 'provider'"
                      >
                        <span class="required">Provider</span>
                      </a>
                    </li>
                    <li :class="[activeTab === 'language' ? 'active' : '']">
                      <a
                        href="#driver-language"
                        data-toggle="tab"
                        @click="activeTab = 'language'"
                      >
                        <span class="required">Language</span>
                      </a>
                    </li>
                    <!-- <li :class="[activeTab === 'pool' ? 'active' : '']">
                      <a
                        href="#driver-pool"
                        data-toggle="tab"
                        @click="activeTab = 'pool'"
                      >
                        <span>Pool</span>
                      </a>
                    </li> -->
                  </ul>
                  <form @submit.prevent="submit">
                    <div class="tab-content">
                      <div
                        id="driver-general"
                        class="tab-pane fade"
                        :class="[activeTab === 'general' ? 'in active' : '']"
                      >
                        <div class="summary-error" v-if="$v.model.$error">
                          This form has errors
                        </div>
                        <div v-if="imageData && !isViewOnly">
                          <cropper
                            class="cropper-box"
                            :src="imagePreview"
                            ref="cropper"
                          />
                        </div>
                        <div
                          class="logo-provider"
                          v-if="!imageData && imagePreview"
                        >
                          <img :src="imagePreview" alt="driver-picture" />
                        </div>
                        <div class="btn-upload-wrapper" v-if="!isViewOnly">
                          <button class="btn btn-upload">
                            <i class="ic-up"></i>
                            {{
                              model.imageUri
                                ? "Change picture"
                                : "Upload picture"
                            }}
                          </button>
                          <input
                            id="image-uploader"
                            type="file"
                            name="imageData"
                            accept="image/jpeg,image/png"
                            v-on:change="onChangeImage($event.target.files)"
                          />
                          <button
                            v-if="imageData"
                            class="btn btn-default btn-block text-center"
                            @click="resetProfilePicture()"
                          >
                            Clear
                          </button>
                        </div>
                        <div class="form-group">
                          <label class="required">Select Title</label>
                          <div
                            class="btn-group btn-group-toggle"
                            data-toggle="buttons"
                          >
                            <label
                              class="btn"
                              :class="{
                                active: model.title === item.value,
                                'field-error':
                                  isSubmitted && $v.model.title.$error,
                              }"
                              v-for="(item, index) in titles"
                              :key="index"
                              @click="model.title = item.value"
                            >
                              <input
                                type="radio"
                                autocomplete="off"
                                :value="item.value"
                                :checked="model.title === item.value"
                                v-model="model.title"
                              />
                              {{ item.text }}
                            </label>
                          </div>
                          <br />
                          <small
                            class="form-text sts-danger"
                            v-if="isSubmitted && !$v.model.title.required"
                            >Title is required</small
                          >
                        </div>
                        <div class="form-group" v-if="model.title === 'Other'">
                          <label class="">Title</label>
                          <input
                            type="text"
                            class="form-control alphabets-only"
                            v-model="model.otherTitle"
                            autocomplete="off"
                          />
                        </div>
                        <div class="form-group">
                          <label class="required">Full Name</label>
                          <input
                            type="text"
                            class="form-control alphabets-characters-only"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.fullName.$error,
                            }"
                            v-model="model.fullName"
                            autocomplete="off"
                            :disabled="isViewOnly"
                          />
                          <div v-if="isSubmitted && $v.model.fullName.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.fullName.required"
                              >Full Name is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.fullName.maxLength"
                              >Full Name must be less than
                              {{ $v.model.fullName.$params.maxLength.max }}
                              characters</small
                            >
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="required">Email</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.email.$error,
                            }"
                            type="text"
                            v-model="model.email"
                            autocomplete="off"
                            :disabled="isViewOnly"
                            placeholder="e.g youremail@gmail.com"
                          />
                          <div v-if="isSubmitted && $v.model.email.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.email.required"
                              >Email is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.email.email"
                              >Email is invalid</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.email.maxLength"
                              >Email must be less than
                              {{ $v.model.email.$params.maxLength.max }}
                              characters</small
                            >
                          </div>
                        </div>
                        <div class="form-group">
                          <label>Alternate Email</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.alternateEmail.$error,
                            }"
                            type="text"
                            v-model="model.alternateEmail"
                            autocomplete="off"
                            :disabled="isViewOnly"
                            placeholder="e.g youremail@gmail.com"
                          />
                          <div
                            v-if="isSubmitted && $v.model.alternateEmail.$error"
                          >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.alternateEmail.email"
                              >Alt. Email is invalid</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.alternateEmail.maxLength"
                              >Alt. Email must be less than
                              {{
                                $v.model.alternateEmail.$params.maxLength.max
                              }}
                              characters</small
                            >
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <label class="required">Phone</label>
                            <div class="row">
                              <div class="col-sm-5">
                                <div class="form-group">
                                  <v-select
                                    class="v-search-select"
                                    :class="{
                                      'field-error':
                                        isSubmitted &&
                                        $v.model.phoneCode.$error,
                                    }"
                                    placeholder="Phone Code"
                                    label="label"
                                    v-model="model.phoneCode"
                                    :options="phoneCodes"
                                    :filter="searchPhoneCode"
                                    :clearable="true"
                                    :searchable="true"
                                    :filterable="true"
                                    :reduce="(option) => option.dial"
                                    :disabled="isViewOnly"
                                  >
                                    <template slot="option" slot-scope="option">
                                      <div class="phone-wrapper">
                                        <div
                                          class="phone-icon"
                                          :class="option.icon"
                                        ></div>
                                        <div class="phone-text">
                                          {{ option.country }}
                                        </div>
                                      </div>
                                    </template>
                                  </v-select>
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      isSubmitted &&
                                      !$v.model.phoneCode.required
                                    "
                                    >Phone Code is required</small
                                  >
                                </div>
                              </div>
                              <div class="col-sm-7">
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control numbers-only"
                                    :class="{
                                      'field-error':
                                        isSubmitted &&
                                        $v.model.phoneNumber.$error,
                                    }"
                                    autocomplete="off"
                                    v-model="sanitizePhoneNumber"
                                    :disabled="isViewOnly"
                                  />
                                  <div
                                    v-if="
                                      isSubmitted && $v.model.phoneNumber.$error
                                    "
                                  >
                                    <small
                                      class="form-text sts-danger"
                                      v-if="!$v.model.phoneNumber.required"
                                      >Phone Number is required</small
                                    >
                                    <small
                                      class="form-text sts-danger"
                                      v-if="!$v.model.phoneNumber.maxLength"
                                      >Phone Number must be less than
                                      {{
                                        $v.model.phoneNumber.$params.maxLength
                                          .max
                                      }}
                                      characters</small
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <label>Alt. Phone</label>
                            <div class="row">
                              <div class="col-sm-5">
                                <div class="form-group">
                                  <v-select
                                    class="v-search-select"
                                    placeholder="Phone Code"
                                    label="label"
                                    v-model="model.alternatePhoneCode"
                                    :options="phoneCodes"
                                    :filter="searchPhoneCode"
                                    :clearable="true"
                                    :searchable="true"
                                    :filterable="true"
                                    :reduce="(option) => option.dial"
                                    :disabled="isViewOnly"
                                  >
                                    <template slot="option" slot-scope="option">
                                      <div class="phone-wrapper">
                                        <div
                                          class="phone-icon"
                                          :class="option.icon"
                                        ></div>
                                        <div class="phone-text">
                                          {{ option.country }}
                                        </div>
                                      </div>
                                    </template>
                                  </v-select>
                                </div>
                              </div>
                              <div class="col-sm-7">
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control numbers-only"
                                    :class="{
                                      'field-error':
                                        isSubmitted &&
                                        $v.model.alternatePhoneNumber.$error,
                                    }"
                                    autocomplete="off"
                                    v-model="sanitizeAltPhoneNumber"
                                    :disabled="isViewOnly"
                                  />
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      isSubmitted &&
                                      !$v.model.alternatePhoneNumber.maxLength
                                    "
                                    >Alt. Phone Number must be less than
                                    {{
                                      $v.model.alternatePhoneNumber.$params
                                        .maxLength.max
                                    }}
                                    characters</small
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group" v-if="!isUpdate">
                          <label class="required">Password</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.password.$error,
                            }"
                            type="password"
                            v-model="model.password"
                            autocomplete="off"
                          />
                          <div v-if="isSubmitted && $v.model.password.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.password.required"
                              >Password is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.password.maxLength"
                              >Password must be less than
                              {{ $v.model.password.$params.maxLength.max }}
                              characters</small
                            >
                          </div>
                        </div>
                      </div>
                      <div
                        id="driver-provider"
                        class="tab-pane fade"
                        :class="[activeTab === 'provider' ? 'in active' : '']"
                      >
                        <div
                          class="summary-error"
                          v-if="$v.model.modifiedProviders.$error"
                        >
                          This form has errors
                        </div>
                        <div
                          class="row"
                          v-for="(item, index) in model.modifiedProviders"
                          :key="index"
                        >
                          <div v-if="item.state !== 'Deleted'">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="required">Provider</label>
                                <v-select
                                  class="v-search-select"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.modifiedProviders.$each[index]
                                        .providerId.$error,
                                  }"
                                  placeholder=""
                                  label="name"
                                  v-model="item.providerId"
                                  :options="providers"
                                  :clearable="true"
                                  :searchable="true"
                                  :filterable="true"
                                  :reduce="(option) => option.id"
                                  :disabled="isViewOnly"
                                  @input="onChangeDriverItem(item)"
                                >
                                </v-select>
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    !$v.model.modifiedProviders.$each[index]
                                      .providerId.required
                                  "
                                  >Provider is required</small
                                >
                              </div>
                            </div>
                            <div class="col-sm-12">
                              <div class="form-group">
                                <button
                                  v-if="
                                    model.modifiedProviders &&
                                    model.modifiedProviders.length > 1 &&
                                    index > 0
                                  "
                                  type="button"
                                  class="btn btn-default sts-danger"
                                  @click.prevent="removeProvider(index)"
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-if="canAddMoreProviders">
                          <div class="col-sm-12">
                            <button
                              v-if="model.modifiedProviders"
                              type="button"
                              class="btn btn-default"
                              @click.prevent="addProvider()"
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        id="driver-language"
                        class="tab-pane fade"
                        :class="[activeTab === 'language' ? 'in active' : '']"
                      >
                        <div
                          class="summary-error"
                          v-if="$v.model.modifiedLanguages.$error"
                        >
                          This form has errors
                        </div>
                        <div
                          class="row"
                          v-for="(item, index) in model.modifiedLanguages"
                          :key="index"
                        >
                          <div v-if="item.state !== 'Deleted'">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label class="required">Language</label>
                                <v-select
                                  class="v-search-select"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.modifiedLanguages.$each[index]
                                        .language.$error,
                                  }"
                                  placeholder=""
                                  label="label"
                                  v-model="item.language"
                                  :options="optionLanguage"
                                  :clearable="true"
                                  :searchable="true"
                                  :filterable="true"
                                  :reduce="(option) => option.text"
                                  :disabled="isViewOnly"
                                  @input="onChangeDriverItem(item)"
                                >
                                </v-select>
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    !$v.model.modifiedLanguages.$each[index]
                                      .language.required
                                  "
                                  >Language is required</small
                                >
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label class="required">Level</label>
                                <v-select
                                  class="v-search-select"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.modifiedLanguages.$each[index]
                                        .level.$error,
                                  }"
                                  placeholder=""
                                  label="text"
                                  v-model="item.level"
                                  :options="proficiencyLevels"
                                  :clearable="false"
                                  :searchable="true"
                                  :filterable="true"
                                  :reduce="(option) => option.text"
                                  :disabled="isViewOnly"
                                  @input="onChangeDriverItem(item)"
                                >
                                </v-select>
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    !$v.model.modifiedLanguages.$each[index]
                                      .level.required
                                  "
                                  >Level is required</small
                                >
                              </div>
                            </div>
                            <div class="col-sm-12">
                              <div class="form-group">
                                <button
                                  v-if="
                                    model.modifiedLanguages &&
                                    model.modifiedLanguages.length > 0
                                  "
                                  type="button"
                                  class="btn btn-default sts-danger"
                                  @click.prevent="removeLanguage(index)"
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="row"
                          v-if="languages && model.modifiedLanguages"
                        >
                          <div class="col-sm-12">
                            <button
                              v-if="model.modifiedLanguages"
                              type="button"
                              class="btn btn-default"
                              @click.prevent="addLanguage()"
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer" v-if="!isViewOnly">
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" role="dialog" ref="driverpasswordmodal">
      <div class="modal-dialog modal-xs">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Driver Authentication</h4>
                <h6>Please fill all information below.</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.auth.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submitAuth()">
                    <div class="form-group">
                      <label class="required">Password</label>
                      <input
                        type="password"
                        class="form-control"
                        :class="{
                          'field-error': isSubmitted && $v.auth.password.$error,
                        }"
                        v-model="auth.password"
                      />
                      <div v-if="isSubmitted && $v.auth.password.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.auth.password.required"
                          >Password is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.auth.password.maxLength"
                          >Password must be less than
                          {{ $v.auth.password.$params.maxLength.max }}
                          characters</small
                        >
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        Save Password
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="deleteItem" @cancel="cancelDelete" />

    <driverDocumentComponent></driverDocumentComponent>
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, email, maxLength } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import driverDocumentComponent from "@/components/master/driver/DriverDocument";
import driverService from "@/services/master/driver/driverService.js";
import providerService from "@/services/master/provider/providerService.js";
import countryPhoneService from "@/services/master/countryPhoneService.js";

export default {
  components: {
    deleteModal,
    driverDocumentComponent,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    isAllowToSync: function () {
      return this.allPermissions.includes("Sync");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    validationRulePassword: function () {
      return !this.isUpdate ? { required, maxLength: maxLength(100) } : {};
    },
    validationRuleProvider: function () {
      return this.model.modifiedProviders &&
        this.model.modifiedProviders.length > 0
        ? { $each: { providerId: { required } } }
        : { $each: { providerId: {} } };
    },
    validationRuleLanguage: function () {
      return this.model.modifiedLanguages &&
        this.model.modifiedLanguages.length > 0
        ? { $each: { language: { required }, level: { required } } }
        : { $each: { language: {}, level: {} } };
    },
    canAddMoreProviders: function () {
      return this.providers && this.providers.length > 1;
    },
    optionLanguage() {
      return this.cekOptionLanguage();
    },
    sanitizePhoneNumber: {
      get() {
        return this.model.phoneNumber;
      },
      set(value) {
        this.model.phoneNumber = value.replace(/\D/g, "");
      },
    },
    sanitizeAltPhoneNumber: {
      get() {
        return this.model.alternatePhoneNumber;
      },
      set(value) {
        this.model.alternatePhoneNumber = value.replace(/\D/g, "");
      },
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: "",
      },
      isSubmitted: false,
      activeTab: "general",
      publicSettings: [],
      allPermissions: [],
      isViewOnly: false,
      itemToBeDeleted: null,
      titles: [],
      providers: [],
      defaultProviderIds: [],
      items: [],
      detail: [],
      phoneCodes: [],
      languages: [],
      proficiencyLevels: [],
      deleteId: null,
      deleteOption: null,
      imagePreview: null,
      imageData: null,
      model: {},
      auth: {},
      isLoading: false,
      isUpdate: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        title: { required },
        otherTitle: {},
        fullName: { required, maxLength: maxLength(150) },
        phoneCode: { required },
        phoneNumber: { required, maxLength: maxLength(20) },
        alternatePhoneNumber: { maxLength: maxLength(20) },
        password: this.validationRulePassword,
        email: { required, email, maxLength: maxLength(100) },
        alternateEmail: { email, maxLength: maxLength(100) },
        modifiedProviders: this.validationRuleProvider,
        modifiedLanguages: this.validationRuleLanguage,
      },
      auth: {
        password: { required, maxLength: maxLength(100) },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    this.publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      this.publicSettings,
      "PageSize",
      25
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
      await this.getProviders();
      await this.getCommon();
      await this.getPhoneCodes();
      this.titles = [
        { value: "Mr", text: "Mr" },
        { value: "Mrs", text: "Mrs" },
        { value: "Ms", text: "Ms" },
        { value: "Other", text: "Others" },
      ];

      if (profile.selectors && profile.selectors["Providers"]) {
        this.defaultProviderIds = profile.selectors["Providers"].ids;
      }
    }
  },
  mounted() {
    $(this.$refs.drivermodal).on("hidden.bs.modal", this.closeDriverModal);
  },
  updated() {
    // subscribe event
    this.$eventBus.$on("openDriverDeleteModal", this.openDeleteModal);
    this.$helper.collapseMenu("fleet-master");
    this.$helper.setNavigationClass("driver-link");
    this.$helper.alphabetsOnly();
    this.$helper.alphabetsCharactersOnly();
    this.$helper.numbersOnly();
    this.$helper.disableContextMenu(".readonly");
  },
  beforeDestroy() {
    // unsubscribe event
    this.$eventBus.$off("openDriverDeleteModal");
  },
  methods: {
    cekOptionLanguage() {
      const data = this.model.modifiedLanguages || [];
      let optLanguages = [];

      if (data.length) {
        data.forEach((val) => {
          if (val.state !== "Deleted") {
            if (optLanguages.length) {
              optLanguages = optLanguages.filter(
                (item) => val.language !== item.value
              );
            } else {
              optLanguages = this.languages.filter(
                (item) => val.language !== item.value
              );
            }
          }
        });
        return optLanguages;
      }

      return this.languages;
    },
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    async onClickSort(column) {
      if (this.table.sort === column) {
        this.table.sortDir = this.table.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.table.sortDir = "asc";
      }
      this.table.sort = column;
      await this.getAll();
    },
    resetModel() {
      this.model = {};
      this.auth = {};
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
      this.$v.auth.$reset();
    },
    searchPhoneCode(options, search) {
      const pattern = new RegExp(search.toLowerCase(), "i");
      return this.phoneCodes.filter((item) => {
        return (
          pattern.test(item.area) ||
          pattern.test(item.country) ||
          pattern.test(item.dial) ||
          pattern.test(item.iata)
        );
      });
    },
    openDriverModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.drivermodal).modal({ backdrop: "static", keyboard: false });
    },
    closeDriverModal() {
      const imageUploader = document.getElementById("image-uploader");
      if (imageUploader) {
        imageUploader.value = "";
      }
      this.imagePreview = null;
      this.imageData = null;
      this.resetModel();
      this.resetValidations();
      $(this.$refs.drivermodal).modal("hide");
    },
    openAuthModal(item) {
      this.resetValidations();
      this.auth = { id: item.id, password: null };
      $(this.$refs.driverpasswordmodal).modal();
    },
    closeAuthModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.driverpasswordmodal).modal("hide");
    },
    async submitAuth() {
      this.isSubmitted = true;
      this.$v.auth.$touch();
      if (this.$v.auth.$error) {
        return;
      }
      try {
        this.isLoading = true;
        await driverService.syncAuth(this.auth);
        this.$notification.success("Successfully synced.", {
          title: "Success",
        });
        this.closeAuthModal();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    createItem() {
      const uploader = document.getElementById("image-uploader");
      if (uploader) {
        uploader.value = "";
      }
      this.isViewOnly = false;
      this.isUpdate = false;
      this.activeTab = "general";
      this.resetModel();
      const modifiedProviders = [];
      if (this.defaultProviderIds && this.defaultProviderIds.length > 0) {
        for (let i = 0; i < this.defaultProviderIds.length; i++) {
          modifiedProviders.push({
            id: this.$helper.emptyGuid(),
            providerId: this.defaultProviderIds[i],
            state: "Created",
          });
        }
      } else {
        modifiedProviders.push({
          id: this.$helper.emptyGuid(),
          providerId: null,
          state: "Created",
        });
      }
      this.openDriverModal({
        title: "Mr",
        phoneNumber: "",
        alternatePhoneNumber: "",
        modifiedProviders: modifiedProviders,
        modifiedLanguages: [
          {
            language: "English",
            level: "Average",
            state: "Created",
          },
        ],
      });
    },
    async updateItem(id) {
      try {
        this.isLoading = true;
        const response = await driverService.getById(id);
        let item = response.data;
        this.isViewOnly = false;
        this.isUpdate = true;
        this.imagePreview = item.imageUri;
        item.modifiedProviders = [];
        item.modifiedLanguages = [];
        this.activeTab = "general";
        item = {
          ...item,
          title: this.findTitle(item.title, "title"),
          otherTitle: this.findTitle(item.title, "otherTitle"),
        };
        this.openDriverModal(item);
        for (let i = 0; i < this.model.providers.length; i++) {
          this.model.modifiedProviders.push({
            id: this.model.providers[i].id,
            providerId: this.model.providers[i].providerId,
            state: "NoAction",
          });
        }
        for (let i = 0; i < this.model.languages.length; i++) {
          this.model.modifiedLanguages.push({
            id: this.model.languages[i].id,
            language: this.model.languages[i].language,
            level: this.model.languages[i].level,
            state: "NoAction",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async viewItem(id) {
      const response = await driverService.getById(id);
      const item = response.data;
      this.isViewOnly = true;
      this.isUpdate = false;
      this.imagePreview = item.imageUri;
      this.openDriverModal(item);
    },
    findTitle(value, type) {
      const findTitle = this.titles.find((val) => val.value === value);

      if (type === "title") return findTitle ? value : "Other";
      else return findTitle ? null : value;
    },
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        if (this.table.sort && this.table.sort !== "") {
          filter += `&sort=${this.table.sort}&sortDir=${this.table.sortDir}`;
        }
        const response = await driverService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getCommon() {
      const common = await driverService.getCommon();
      this.languages = common.languages;
      this.proficiencyLevels = common.proficiencyLevels;
      for (let i = 0; i < this.languages.length; i++) {
        const language = this.languages[i];
        language.label = this.humanize(language.text).trim();
      }
    },
    async getProviders() {
      this.providers = await providerService.getAllActive();
    },
    async getPhoneCodes() {
      this.phoneCodes = await countryPhoneService.getAll();

      for (let i = 0; i < this.phoneCodes.length; i++) {
        const item = this.phoneCodes[i];
        item.label = `+${item.dial}`;
        item.icon = `iti-flag ${item.iata.toLowerCase()}`;
      }
    },
    async submit() {
      this.model.modifiedProviders = this.model.modifiedProviders.filter(
        (x) => x.providerId
      );
      this.model.email = this.model.email
        ? this.model.email.toLowerCase()
        : null;
      this.model.alternateEmail = this.model.alternateEmail
        ? this.model.alternateEmail.toLowerCase()
        : null;

      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        this.model.title =
          this.model.title === "Other"
            ? this.model.otherTitle
            : this.model.title;
        this.model.isChangeStatus = false;
        this.model.providers = this.model.modifiedProviders;
        this.model.languages = this.model.modifiedLanguages.map((x) => x);
        if (this.isUpdate) {
          await driverService.update(this.model);
          await this.uploadImage(this.model.id);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          const response = await driverService.create(this.model);
          await this.uploadImage(response.data);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        this.closeDriverModal();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        if (item.isActive) {
          await driverService.reactivate({ id: item.id });
          this.$notification.success("Successfully reactivated.", {
            title: "Success",
          });
        } else {
          await driverService.deactivate({ id: item.id });
          this.$notification.success("Successfully deactivated.", {
            title: "Success",
          });
        }
        await this.getAll();
      } catch (error) {
        item.isActive = !item.isActive;
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    printPhone(item) {
      return item.phoneCode &&
        item.phoneNumber &&
        item.phoneCode.length > 0 &&
        item.phoneNumber.length > 0
        ? `(+${item.phoneCode}) ${item.phoneNumber}`
        : "";
    },
    onChangeImage(files) {
      const maxSize = 4 * 1024 * 1024;
      if (files[0].size > maxSize) {
        this.imagePreview = null;
        this.imageData = null;
        document.getElementById("image-uploader").value = "";
        alert(
          `File is too big, max-size is  ${parseInt(maxSize / 1000000)}MB.`
        );
        return;
      }
      if (
        !["jpeg", "jpg", "png"].includes(
          files[0].name
            .substring(files[0].name.lastIndexOf(".") + 1)
            .toLowerCase()
        )
      ) {
        this.imagePreview = null;
        this.imageData = null;
        document.getElementById("image-uploader").value = "";
        alert("Invalid file type.");
        return;
      }
      this.imagePreview = URL.createObjectURL(files[0]);
      this.imageData = files[0];
    },
    async uploadImage(id) {
      const uploader = document.getElementById("image-uploader");
      if (uploader.value && uploader.value !== "") {
        const { canvas } = this.$refs.cropper.getResult();
        if (canvas) {
          const model = {
            id: id,
          };
          const formData = new FormData();
          for (const key in model) {
            if (model.hasOwnProperty(key)) {
              formData.append(key, model[key]);
            }
          }
          const blob = await new Promise((resolve) => canvas.toBlob(resolve));
          formData.append("file", blob, this.imageData.name);
          await driverService.uploadImage(formData);
        }
      }
    },
    resetProfilePicture() {
      this.imageData = null;
      this.imagePreview = null;
      document.getElementById("image-uploader").value = "";
    },
    openDeleteModal(option, id) {
      this.deleteOption = option;
      this.deleteId = id;
      $("#deletemodal").modal();
    },
    cancelDelete() {
      switch (this.deleteOption) {
        case "driverDocument":
          // publish message
          this.$eventBus.$emit("openModalDriverDocument", this.deleteId);
          break;
      }
      this.deleteId = null;
      this.deleteOption = null;
      $("#deletemodal").modal("hide");
    },
    async deleteItem() {
      try {
        this.isLoading = true;
        switch (this.deleteOption) {
          case "driver":
            try {
              await driverService.delete(this.deleteId);
              this.$notification.success("Successfully deleted.", {
                title: "Success",
              });
              await this.getAll();
            } catch (error) {
              if (error.errors) {
                for (let index = 0; index < error.errors.length; index++) {
                  this.$notification.error(error.errors[index], {
                    title: "Error",
                  });
                }
              }
            }
            break;
          case "driverDocument":
            // publish message
            this.$eventBus.$emit("deleteDriverDocument", this.deleteId);
            break;
        }
        this.deleteId = null;
        this.deleteOption = null;
        $("#deletemodal").modal("hide");
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    viewDocument(item) {
      // publish message
      this.$eventBus.$emit("initializeDriverDocument", item);
    },
    printProvider(item) {
      return item.providers.length === 1
        ? item.providers[0].providerName
        : `${item.providers.length} providers`;
    },
    printLanguage(item) {
      return item.languages.length === 1
        ? item.languages[0].language
        : `${item.languages.length} languages`;
    },
    addProvider() {
      this.model.modifiedProviders.push({
        id: this.$helper.emptyGuid(),
        providerId: null,
        state: "Created",
      });
    },
    removeProvider(index) {
      this.model.modifiedProviders[index].state = "Deleted";
      const modifiedProviderData = this.model.modifiedProviders[index];
      if (!modifiedProviderData.providerId) {
        this.model.modifiedProviders.splice(index, 1);
      }
    },
    addLanguage() {
      this.model.modifiedLanguages.push({
        id: this.$helper.emptyGuid(),
        language: null,
        level: null,
        state: "Created",
      });
    },
    removeLanguage(index) {
      this.model.modifiedLanguages[index].language = this.model
        .modifiedLanguages[index].language
        ? this.model.modifiedLanguages[index].language
        : "Unspecified";
      this.model.modifiedLanguages[index].level = this.model.modifiedLanguages[
        index
      ].level
        ? this.model.modifiedLanguages[index].level
        : "Limited";
      this.model.modifiedLanguages[index].state = "Deleted";
    },
    onChangeDriverItem(item) {
      if (item.id === this.$helper.emptyGuid()) {
        item.state = "Created";
      } else {
        item.state = "Updated";
      }
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/driver/Driver.vue